import React from "react";
import { bindActionCreators } from "redux";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlusSquare, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { moduleDelete, moduleGetSearch } from "actions/module/requests";
import CommonTable from "../../lib/components/CommonTable";

const Module = ({
                  getList,
                  // moduleDelete,
                  list,
                  // ...rest
                }) => {
  /*
    const handleDelete = (ev, id) => {
      ev.preventDefault();
      moduleDelete(id);
    };
  */

  const getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
    },
    {
      id: "version",
      Header: "Version",
      accessor: "version",
    },
    /*
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerModule: "text-center",
        // eslint-disable-next-line react/display-name
      Cell: ({original}) => (
          <Link to={`/module/edit/${original.id}`} className="btn btn-sm mx-2 btn-warning">
              <FontAwesomeIcon icon={faPencilAlt}/>
          </Link>
      )
    },
    */
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={() => (
        <div className="d-flex justify-content-between align-items-center">
          <h1>Module</h1>
          {/*
                <Link to="/module/create" className="btn btn-success">
                    <FontAwesomeIcon icon={faPlusSquare} title="Create New"/>
                </Link>
                */}
        </div>
      )}
      searchHookProps={{
        size: 20,
        sort: "id,asc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  loading: state.module.loading,
  list: state.module.list
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(moduleGetSearch, dispatch),
  moduleDelete: bindActionCreators(moduleDelete, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Module);



// WEBPACK FOOTER //
// ./src/views/pages/Module/index.js